<template>
	<router-link
		:to="targetRoute"
		:class="{ button, 'is-link': link }"
		v-bind="$attrs"
		active-class="is-active"
		v-on="$listeners">
		<slot />
	</router-link>
</template>

<script>
export default {
	name: 'DpLink',
	props: {
		params: { type: Object, default: () => ({}) },
		query: { type: Object, default: () => ({}) },
		routeName: { type: String, default: null },
		button: { type: Boolean, default: false },
		link: { type: Boolean, default: false },
	},
	computed: {
		targetRoute() {
			const { name, params, query } = this.$route;
			return {
				name: this.routeName || name,
				query: { ...query, ...this.query },
				params: { ...params, ...this.params },
			};
		},
	},
};
</script>
